module.exports = __webpack_public_path__ + "static/media/Login-page.d8480d60.png";